import {
  AppstoreOutlined,
  BarChartOutlined,
  CheckSquareOutlined,
  DashboardOutlined,
  FilterOutlined,
  FundProjectionScreenOutlined,
  IdcardOutlined,
  ProjectOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.css";

const illustrations = {
  dashboard: {
    icon: DashboardOutlined,
    secondaryIcon: BarChartOutlined,
    accent: "#3b82f6",
  },
  users: {
    icon: UserOutlined,
    secondaryIcon: TeamOutlined,
    accent: "#8b5cf6",
  },
  teams: {
    icon: TeamOutlined,
    secondaryIcon: UserOutlined,
    accent: "#14b8a6",
  },
  roles: {
    icon: SafetyCertificateOutlined,
    secondaryIcon: UserOutlined,
    accent: "#f59e0b",
  },
  customers: {
    icon: IdcardOutlined,
    secondaryIcon: UserOutlined,
    accent: "#ec4899",
  },
  projects: {
    icon: ProjectOutlined,
    secondaryIcon: CheckSquareOutlined,
    accent: "#6366f1",
  },
  reports: {
    icon: BarChartOutlined,
    secondaryIcon: DashboardOutlined,
    accent: "#0ea5e9",
  },
  kanban: {
    icon: AppstoreOutlined,
    secondaryIcon: CheckSquareOutlined,
    accent: "#10b981",
  },
  tasks: {
    icon: CheckSquareOutlined,
    secondaryIcon: ProjectOutlined,
    accent: "#22c55e",
  },
  gantt: {
    icon: FundProjectionScreenOutlined,
    secondaryIcon: BarChartOutlined,
    accent: "#f97316",
  },
  filters: {
    icon: FilterOutlined,
    secondaryIcon: SettingOutlined,
    accent: "#64748b",
  },
  actions: {
    icon: SettingOutlined,
    secondaryIcon: CheckSquareOutlined,
    accent: "#06b6d4",
  },
};

const TourIllustration = ({ variant = "dashboard" }) => {
  const illustration = illustrations[variant] ?? illustrations.dashboard;
  const MainIcon = illustration.icon;
  const SecondaryIcon = illustration.secondaryIcon;

  return (
    <div
      className={styles.root}
      style={{ "--tour-illustration-accent": illustration.accent }}
      aria-hidden="true"
    >
      <span className={`${styles.blob} ${styles.blobTop}`} />
      <span className={`${styles.blob} ${styles.blobBottom}`} />

      <div className={styles.panel}>
        <div className={styles.panelHeader}>
          <span />
          <span />
          <span />
        </div>
        <div className={styles.panelBody}>
          <span className={styles.lineLong} />
          <span className={styles.lineShort} />
          <div className={styles.chart}>
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>

      <div className={styles.mainIcon}>
        <MainIcon />
      </div>
      <div className={styles.secondaryIcon}>
        <SecondaryIcon />
      </div>
      <span className={styles.check}>✓</span>
    </div>
  );
};

export default TourIllustration;
